
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookshelf/[[...slug]]",
      function () {
        return require("private-next-pages/bookshelf/[[...slug]].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookshelf/[[...slug]]"])
      });
    }
  